enum LanguageCodes {
  ENGLISH = "en",
  CHINESE = "zh-CN",
  SPANISH = "es",
  FRENCH = "fr",
}

export default LanguageCodes;
